import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "../../components/ui/carousel";
import { cn } from "../../lib/utils";
import { CircleUserRound } from "lucide-react";
import { stripHtml } from "../../utils/util-functions/stripHTML";
import { stripText } from "../../utils/util-functions/stripText";
import Autoplay from "embla-carousel-autoplay";
import QUOTES from "../../assets/Quotes.png";
import StudentFeedbackCard from "./StudentFeedbackCard";

const StudentFeedbackCarousel = ({ data }) => {
    return (
        <div>
            <Carousel
                className={cn("lg:w-[55rem] w-[24rem]")}
                plugins={[
                    Autoplay({
                        delay: 4000,
                    }),
                ]}
            >
                <CarouselPrevious />
                <CarouselContent>
    {data.map((ele, index) => (
        <CarouselItem
            key={index}
            className="pl-4 basis-full"
        >
            <div className="p-1">
                <CardContent
                    className="flex flex-col items-center justify-around p-6"
                >
                    <StudentFeedbackCard {...ele} key={index} />
                </CardContent>
            </div>
        </CarouselItem>
    ))}
</CarouselContent>

                <CarouselNext />
            </Carousel>
        </div>
    );
};

export default StudentFeedbackCarousel;
